// ============================================================
// HostessCenter 多主题样式配置
// index.vue、Level.vue 共用（变量挂在父级根节点，子组件继承）
// ============================================================

const styObj = {
  default: {
    // ---- index.vue：Tab 下划线、弹窗按钮 ----
    '--theme-hostess-center-tab-underline': '#925dff',
    '--theme-level-dia-btn-bg': '#a338fc',
    '--theme-level-dia-btn-color': '#ffffff',

    // ---- Level.vue：强调色与次要文案 ----
    '--theme-call-income-accent': '#925dff',
    '--theme-income-bean-img-w': '11px',
    '--theme-week-muted': '#999999',
    '--theme-level-num-inactive': '#999999',
    '--theme-level-tab-active': '#925dff',
    '--theme-level-tab-underline': '#d7c7fc',
    '--theme-right-desc-accent': '#925dff',
    '--theme-right-desc-icon-w': '18px',
    '--theme-right-text-muted': '#999999',
    '--theme-wrapper-muted': '#999999',
    '--theme-swipe-indicator-active': '#a338fc',
    '--theme-table-td-muted': '#999999',
  },

  kiko: {
    '--theme-hostess-center-tab-underline': '#333333',
    '--theme-level-dia-btn-bg': '#ffe242',
    '--theme-level-dia-btn-color': '#000000',

    '--theme-call-income-accent': '#b79b21',
    '--theme-income-bean-img-w': '14px',
    '--theme-week-muted': '#b2b2b2',
    '--theme-level-num-inactive': '#b2b2b2',
    '--theme-level-tab-active': '#333333',
    '--theme-level-tab-underline': '#333333',
    '--theme-right-desc-accent': '#b79b21',
    '--theme-right-desc-icon-w': '14px',
    '--theme-right-text-muted': '#b2b2b2',
    '--theme-wrapper-muted': '#b2b2b2',
    '--theme-swipe-indicator-active': '#b79b21',
    '--theme-table-td-muted': '#b2b2b2',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        return styObj['default']
      }
      return {}
    },
  },
}
